export const SiteMembersApiSymbol = Symbol('SiteMembersApi')
export const SMPopupsSymbol = Symbol('SMPopups')

export const name = 'siteMembers' as const

export const DialogComponentId = 'SM_ROOT_COMP'
export { VSM_EDITOR_CONFIGS_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
